import React, { Component } from "react";
import { alert, loading, t } from "../../components/CustomComponent.js";
import { withRouter } from "../../components/withRouter.js";

import HomeNavbar from "./components/HomeNavbar.js";
import HomeHero from "./components/HomeHero.js";
import HomeCategories from "./components/HomeCategories.js";
import HomePromo from "./components/HomePromo.js";
import HomeFeatured from "./components/HomeFeatured.js";
import HomeProjects from "./components/HomeProjects.js";
import HomeTransit from "./components/HomeTransit.js";
import HomeAbout from "./components/HomeAbout.js";
import HomePartner from "./components/HomePartner.js";
import HomeArticles from "./components/HomeArticles.js";
import HomeCta from "./components/HomeCta.js";
import HomeFooter from "./components/HomeFooter.js";

import ICON from "./icons.js";
import { shortcutParams, shortcutTitle, openFreePost, openPartner } from "./options.js";
import { EMPTY_CONTENT, loadHomeContent } from "./api.js";
import { favMap, favToggle, favSubscribe } from "./fav_store.js";
import "../../assets/css/bootstrap.css";
import "../../assets/css/style.css";
import "../../assets/css/homepage.css";
import "../../assets/css/partner.css";

/* ============================================================================
 * HomePage — หน้าแรกฝั่งผู้ใช้ทั่วไป (public)
 *
 * โครงหน้า (เรียงตามลำดับสายตา)
 *   1. เมนูบน               HomeNavbar
 *   2. ภาพหลัก + ค้นหา      HomeHero
 *   3. หมวดหมู่ยอดนิยม      HomeCategories
 *   4. แบนเนอร์ + ลงประกาศ  HomePromo
 *   5. ทรัพย์แนะนำ          HomeFeatured
 *   6. โครงการ + ไลฟ์สไตล์  HomeProjects (2 คอลัมน์)
 *   7. แนวรถไฟฟ้า           HomeTransit
 *   8. จุดเด่น + ตัวเลข      HomeAbout (2 คอลัมน์)
 *   9. ชวนเป็นพาร์ตเนอร์     HomePartner
 *  10. บทความ               HomeArticles
 *  11. แถบติดต่อ            HomeCta
 *  12. ฟุตเตอร์             HomeFooter
 *
 * ลำดับนี้พาผู้ใช้จาก "ค้นหาเอง" (ช่องค้นหา + หมวดหมู่) ไปสู่ "ให้เราแนะนำ"
 * (ทรัพย์ / โครงการ / แนวรถไฟฟ้า) แล้วจึงปิดท้ายด้วยความน่าเชื่อถือและการติดต่อ
 *
 * ข้อมูลทั้งหน้ามาจาก GET home/content ครั้งเดียว (เนื้อหาที่ผู้ดูแลตั้งไว้ +
 * ทรัพย์และโครงการที่เผยแพร่จริง) หน้าแรกจึงขึ้นครบพร้อมกัน ไม่ทยอยโผล่ทีละส่วน
 * ========================================================================== */
class HomePage extends Component {
  state = {
    content: EMPTY_CONTENT,
    favorites: favMap(), // { [uid]: true } อ่านจาก fav_store — คงอยู่ข้ามการรีเฟรช
    fav_pop: "",         // uid ที่กำลังเล่น effect ปุ่มหัวใจ (เหมือนหน้าทรัพย์ฝั่งแอดมิน)
    show_top: false,
  };

  componentDidMount() {
    document.title = "SafeSpace Life Living";
    window.addEventListener("scroll", this.onScroll, { passive: true });
    // หัวใจบนการ์ดต้องตรงกับที่เก็บไว้เสมอ แม้ผู้ใช้ไปลบทิ้งจากหน้ารายการโปรดอีกแท็บ
    this.unsubscribeFav = favSubscribe(() => this.setState({ favorites: favMap() }));
    this.Get();
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.onScroll);
    this.unsubscribeFav();
    clearTimeout(this.fav_timer);
  }

  Get = async () => {
    loading(true);
    const content = await loadHomeContent();
    loading(false);

    /* เลื่อนไปยัง #anchor หลังข้อมูลมาแล้ว (เช่นกดเมนูจากหน้ารายละเอียดทรัพย์)
       ถ้าเลื่อนก่อนเนื้อหาวางเสร็จจะได้ตำแหน่งผิด เพราะความสูงหน้ายังไม่นิ่ง */
    this.setState({ content }, () => {
      const hash = window.location.hash;
      if (!hash) return window.scrollTo({ top: 0 });
      setTimeout(() => {
        const target = document.querySelector(hash);
        if (target) window.scrollTo({ top: target.offsetTop - 90, behavior: "smooth" });
      }, 0);
    });
  };

  onScroll = () => {
    const show_top = window.scrollY > 640;
    if (show_top !== this.state.show_top) this.setState({ show_top });
  };

  /* เมนู/ปุ่มที่ยังไม่มีหน้าปลายทาง : แจ้งเตือนแบบเดียวกับเมนู coming soon ฝั่งแอดมิน */
  soon = (name) => alert("", "info", t("coming_soon_title"), `${name} — ${t("coming_soon_desc")}`, t("confirm"));

  /* กดการ์ดทรัพย์/โครงการ = เปิดหน้ารายละเอียดในแท็บใหม่
     เปิดแท็บใหม่เพื่อให้ผู้ใช้เทียบหลายรายการพร้อมกันได้ โดยไม่เสียผลการค้นหา
     และตำแหน่งที่เลื่อนค้างไว้ในหน้าแรก — noopener กันหน้าใหม่เข้าถึง window.opener */
  openProperty = (item) => window.open(`/property/${item.id}`, "_blank", "noopener,noreferrer");

  /* กดหัวใจ = เขียนลง fav_store ทันที ส่วน state.favorites อัปเดตผ่าน favSubscribe
     ที่ผูกไว้ตอน mount จึงไม่ต้องแก้ที่นี่ซ้ำ (แหล่งความจริงมีที่เดียวคือ store) */
  toggleFavorite = (uid) => {
    clearTimeout(this.fav_timer);
    favToggle(uid);
    this.setState({ fav_pop: uid }); // ติดคลาส is-pop ให้ CSS เล่น effect เด้ง + วงกระเพื่อม
    this.fav_timer = setTimeout(() => this.setState({ fav_pop: "" }), 600);
  };

  /* เปิดหน้ารายการทรัพย์เป็นแท็บใหม่ พร้อมเงื่อนไขที่ติดไปกับ URL
     แท็บใหม่เพราะผู้ใช้ยังอยู่ระหว่างไล่ดูหน้าแรก — กลับมาที่เดิมได้โดยไม่เสียตำแหน่ง */
  openList = (params) => {
    const query = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => value && query.set(key, value));
    window.open(`/properties?${query.toString()}`, "_blank", "noopener,noreferrer");
  };

  /* ปุ่มค้นหาในกล่องหน้าแรก — ส่งทุกช่องที่เลือกไว้ต่อไปให้หน้ารายการค้นจริง */
  search = (form) =>
    this.openList({ zone: form.zone, type: form.type, project: form.project, deal: form.deal, price: form.price, bed: form.bed });

  /* ทางลัดค้นหา (หมวดหมู่ / ไลฟ์สไตล์ / แนวรถไฟฟ้า)
     ปลายทางที่ตั้งไว้หลังบ้าน (tag=transit / type=condo ...) ถูกแปลงเป็นเงื่อนไขจริง
     ที่ options.js — ค่าดิบอย่าง "tag=promo" จึงไม่หลุดไปโผล่ใน URL หรือบนหน้ารายการ
     ส่วน title คือชื่อปุ่มที่ผู้ใช้กด ใช้เป็นหัวข้อของหน้าปลายทาง */
  shortcut = (item) => this.openList({ ...shortcutParams(item), title: shortcutTitle(item) });

  subscribe = (email) => {
    if (!email) return alert("", "warning", t("warning"), t("home_footer_email_required"), t("confirm"));
    alert("", "success", t("success"), t("home_footer_subscribe_done"), t("confirm"));
  };

  render() {
    const { content, favorites, fav_pop, show_top } = this.state;

    return (
      <div className="mn-home">
        {/* ปุ่มรายการโปรดของเมนูเปิดหน้า /favorites เป็นแท็บใหม่ให้เองแล้ว */}
        <HomeNavbar onPost={openFreePost} />

        <HomeHero
          hero={content.hero}
          zones={content.zones}
          types={content.types}
          project_names={content.project_names}
          onSearch={this.search}
        />

        <HomeCategories items={content.categories} onSelect={this.shortcut} />

        <HomePromo banners={content.banners} onPost={openFreePost} />

        <HomeFeatured
          items={content.properties}
          favorites={favorites}
          fav_pop={fav_pop}
          onFavorite={this.toggleFavorite}
          onOpen={this.openProperty}
          onViewAll={() => this.openList({ section: "featured" })}
        />

        <HomeProjects
          items={content.projects}
          lifestyles={content.lifestyles}
          onOpen={this.openProperty}
          onLifestyle={this.shortcut}
          onViewAll={() => this.openList({ section: "projects" })}
        />

        <HomeTransit data={content.transit} onSelect={this.shortcut} />

        <HomeAbout data={content.features} />

        {/* ชวนร่วมงานหลังจากเห็นตัวเลขความน่าเชื่อถือแล้ว — พาไปหน้าใบสมัคร /partner
            ใช้ navigate ของ router ไม่ใช่ window.location : หน้าใบสมัครอยู่ในแอปเดียวกัน
            เปลี่ยนหน้าแบบ client-side จึงขึ้นทันที ไม่ต้องรอโหลดบันเดิลใหม่ */}
        <HomePartner onApply={() => openPartner(this.props.router.navigate)} />

        <HomeArticles
          data={content.articles}
          onOpen={(item) => this.soon(item.title)}
          onViewAll={() => window.open("/articles", "_blank", "noopener,noreferrer")}
        />

        {/* ช่องทางติดต่อมาจาก "ตั้งค่า › ข้อมูลบริษัท" และ HomeCta จัดการการกดเอง
            (โทร / เพิ่มเพื่อน LINE / ส่งอีเมล) หน้านี้จึงส่งมาแค่ข้อความหัวเรื่อง */}
        <HomeCta data={content.contact.bar} />

        <HomeFooter
          data={content.contact.footer}
          socials={content.contact.socials}
          onLink={(key) => this.soon(t(key))}
          onSubscribe={this.subscribe}
        />

        {/* ปุ่มกลับขึ้นบน : โผล่เมื่อเลื่อนลงมาพอสมควร */}
        {show_top && (
          <button
            type="button"
            className="hm-to-top"
            aria-label={t("home_back_to_top")}
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          >
            <span className="hm-ico">{ICON.chevron_up}</span>
          </button>
        )}
      </div>
    );
  }
}

export default withRouter(HomePage);
